import { RegionViewModel } from "../viewmodels/RegionViewModel.js";
import { useDownloadsApiServiceContext } from "../../../contexts/DownloadsApiServiceContext.js";
import { useEffect, useMemo } from "react";
import { useSingleton } from "mvc-kit/react";
//#region src/modules/AppWrapper2/components/DownloadsRegionSync.tsx
/**
* Bridges the selected regions into DownloadsApiServiceContext, which threads
* them into the downloads-api request headers so PDF/report downloads stay
* region-scoped.
*
* This needs a React component: RegionViewModel is a plain class and cannot
* reach a React context, but the v1 hook this replaced called setRegionIds()
* alongside rpcClient.setIdentityMetadata(). Both are driven off the same
* `scopedRegionIds` getter so the two can't disagree.
*/
function DownloadsRegionSync() {
	const regionVM = useSingleton(RegionViewModel);
	const { setRegionIds } = useDownloadsApiServiceContext({ ctxRequired: false });
	const regionIds = useMemo(() => regionVM.scopedRegionIds, [regionVM.scopedRegionIds.join(",")]);
	useEffect(() => {
		setRegionIds?.(regionIds);
	}, [regionIds, setRegionIds]);
	return null;
}
//#endregion
export { DownloadsRegionSync };

//# sourceMappingURL=DownloadsRegionSync.js.map